(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-product"] && !Shopify.designMode) return;
  try {
    
var hotSpot = document.querySelectorAll(".shoppable-item__hotspot");
for (var i = 0; i < hotSpot.length; i++) {
  var el = hotSpot[i];
  el.addEventListener("click", function () {
    var itemId = i;
    var allhotSpot = document.querySelectorAll(".shoppable-item__hotspot");
    if (this.nextElementSibling.className.match("hidden")) {
      this.nextElementSibling.classList.remove("hidden");
    } else {
      this.nextElementSibling.classList.add("hidden");
    }
    for (var j = 0; j < allhotSpot.length; j++) {
      if (this == allhotSpot[j]) {
        continue;
      }
      allhotSpot[j].nextElementSibling.classList.add("hidden");
    }
  });
}

var a = document.querySelectorAll('.shoppable-item__close, .shoppable-image-wrapper');
a.forEach(closeBtn => {
  closeBtn.addEventListener('click', closeCard)
});
function closeCard() {
  var a = document.querySelectorAll('.shoppable-item__product-card');
  for(var i = 0; i < a.length; i++) {
    a[i].classList.add('hidden');
  }
};

  } catch(e) { console.error(e); }
})();
})();
